import React, { useState, FunctionComponent, useEffect, useRef } from 'react';
import { Presentation } from './presentation';
import type { OperatingCompanyProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const [isHeroActive, setIsHeroActive] = useState(false);
  const infoRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setIsHeroActive(true);
    });
    return () => cancelAnimationFrame(id);
  }, []);
  
  const handleScrollToInfo = () => {
    if (!infoRef.current) return;
    const rect = infoRef.current.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: rect - 64, behavior: "smooth" });
  };

  return (
    <Presentation
      {...props}
      isHeroActive={isHeroActive}
      infoRef={infoRef}
      onClickScroll={handleScrollToInfo}
    />
  );
};
